import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { selectGlobalUserInfo } from 'state/global/auth/selector';
import { selectGlobalMyProfile } from 'state/global/profile/selector';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import { getUserName } from 'util/auth';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationOverview } from './components/NotificationOverview';
import { MachineLocation } from './components/MachineLocation';
import { MachineStatus } from './components/MachineStatus';
import * as selector from './state/selector';
import { CUSTOM_PAGE_SIZE, STATE_PROP_MACHINE_OVERVIEW } from './util/constant';
import { fetchMachinesOverviews } from './state/operation';

export const Overview = () => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.OVERVIEW);
  const globalUserInfo = useSelector((state) => selectGlobalUserInfo(state));
  const globalMyProfile = useSelector((state) => selectGlobalMyProfile(state));

  const dispatch = useDispatch();
  const { machineOverview } = useSelector((state) => ({
    machineOverview: selector.selectMachineOverview(state)
  }));

  const [pagination, setPagination] = useState({
    page: 1,
    limit: CUSTOM_PAGE_SIZE,
    stateProp: STATE_PROP_MACHINE_OVERVIEW
  });

  const handlePageChange = (page) => {
    setPagination((currentPagination) => ({
      ...currentPagination,
      page
    }));
  };

  useEffect(() => {
    dispatch(
      fetchMachinesOverviews({
        limit: pagination.limit,
        page: pagination.page
      })
    );
  }, [dispatch, pagination.limit, pagination.page]);

  return (
    <div className="overview">
      <div className="page-header">
        <h1 className="page-title">
          {t('userWelcome', {
            fullName: getUserName(
              globalUserInfo?.name,
              globalMyProfile?.displayName
            )
          })}
        </h1>
        <h5 className="page-description">{t('pageRole')}</h5>
      </div>

      <Row gutter={[24, { xs: 32, sm: 32, xl: 24 }]} className="page-body">
        <Col xs={24} sm={24} xl={12}>
          <MachineStatus
            machineOverview={machineOverview}
            pagination={pagination}
            onPageChange={handlePageChange}
          />

          <NotificationOverview />
        </Col>

        <Col xs={24} sm={24} xl={12}>
          <MachineLocation machineOverview={machineOverview} />
        </Col>
      </Row>
    </div>
  );
};
